module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-side"
  }, [_c('el-menu', {
    attrs: {
      "default-active": _vm.defaultIndex
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_c('i', {
    staticClass: "el-icon-message"
  }), _vm._v("翻译示例")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/test"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "2"
    }
  }, [_c('i', {
    staticClass: "el-icon-menu"
  }), _vm._v("表格示例")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4bdf723b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 154
// module chunks = 2